<div class="container mt-2">
  <div class="p-3 mb-4 bg-light border rounded-3">
    <h1 class="lead">
      Welcome to Flash Disk Prices! Your one-stop destination for comparing prices and
      features on flash drives from all the top brands. We make it easy to find the
      perfect drive for your needs and budget.
    </h1>
<!--    <p class="small mb-0">-->
<!--      <strong>Please note:</strong> To help keep this service free, we may earn a-->
<!--      commission from qualifying purchases made through our links, at no extra cost to you.-->
<!--      While we work hard to keep our data current, prices can change quickly, so you may see-->
<!--      a different price when you click our affiliate link.-->
<!--    </p>-->
  </div>

  @if (allProducts.length) {
    <div class="count-alignment-container">
      <div class="spacer"></div>
      <div class="record-count">
        Viewing {{ rowData.length }} of {{ allProducts.length }} products
      </div>
    </div>
  }
  <div class="page-container">
    <div class="left-panel-container">

<!--      <app-data-source-filter-panel-->
<!--        [title]="dataSourcePanelTitle"-->
<!--        [dataSourceFilterList]="dataSourceFilterList"-->
<!--        (selectionChanged)="onDataSourceFilterSelectionChange($event)"-->
<!--      >-->
<!--      </app-data-source-filter-panel>-->

      <app-brand-filter-panel
        [title]="brandPanelTitle"
        [brandFilterList]="brandFilterList"
        (selectionChanged)="onBrandFilterSelectionChange($event)"
      >
      </app-brand-filter-panel>

      <app-price-filter-panel
        [title]="pricePanelTitle"
        [priceFilterList]="priceFilterList"
        (selectionChanged)="onPriceFilterSelectionChange($event)"
      >
      </app-price-filter-panel>

      <app-capacity-filter-panel
        [title]="capacityPanelTitle"
        [capacityFilterList]="capacityFilterList"
        (selectionChanged)="onCapacityFilterSelectionChange($event)"
      >
      </app-capacity-filter-panel>

      <app-hardware-interface-filter-panel
        [title]="interfacePanelTitle"
        [interfaceFilterList]="interfaceFilterList"
        (selectionChanged)="onInterfaceFilterSelectionChange($event)"
      >
      </app-hardware-interface-filter-panel>

      <app-link-panel
        [title]="siteLinksTitle"
        [links]="siteLinks"
      ></app-link-panel>
    </div>
    @if (isBrowser) {
      <div class="product-list-container">
        <app-product-list [rowData]="rowData"></app-product-list>
      </div>
    }
  </div>
</div>
